// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"styles_loaderWrapper__3ioRM","loaderDot":"styles_loaderDot__sGUoq","dot-keyframes":"styles_dot-keyframes__2q7Yv"};